import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'ol/ol.css';
import GTMProvider from './components/providers/gtm-provider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GTMProvider>
      <App />
    </GTMProvider>
  </React.StrictMode>
);

reportWebVitals();
